




































































































































































































































































































































































































































































































































import { Component } from "vue-property-decorator";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { mixins } from "vue-class-component";
import { i18n } from "@/resources/locales";
import GraphicClient from "@/resources/mixins/graphicClient/graphicClient";
import {
  MessageType,
  UserSendMessageType,
} from "@/resources/constants/graphicClient/graphicClient";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";
@Component({
  name: "game-killer-info-modal-component",
})
export default class GameKillerInfoModalComponent extends mixins(
  NotificationEvent
) {
  isMinimized = false;
  activeVoting = false;
  activeReport = false;
  listUsers = [];
  loadUsers = false;
  loadReport = false;
  loadVote = false;
  selectedUser = "";
  description = "";
  totalVotes = 0;
  expulsionYes = false;
  expulsionNo = false;
  timePoll = "";
  textButonReport = i18n.t("gameKiller.report");
  timerVote = null;
  timerReport = null;
  timerKiller = null;
  textTimerKiller = "";
  timerBan = null;
  isShowDiary = true;
  mounted() {}
  get active() {
    const e = this.$store.getters["SystemStore/getGameKillerInfoModal"];
    if (e) {
      setTimeout(() => {
        if (this.space.assassinGame) {
          let data = {
            killsCounter: this.space.assassinGame.killsCounter,
            gameFinishAtKillsCounter:
              this.space.assassinGame.gameFinishAtKillsCounter,
            startedAt: this.space.assassinGame.startedAt,
            lastKillAt: this.space.assassinGame.lastKillAt,
            lastReportAt: this.space.assassinGame.lastReportAt,
            lastSpaceUserReporterName:
              this.space.assassinGame.lastSpaceUserReporterName,
            lastSpaceUserReportedName:
              this.space.assassinGame.lastSpaceUserReportedName,
            pollDescription: this.space.assassinGame.pollDescription,
            pollCounterNo: this.space.assassinGame.pollCounterNo,
            pollCounterYes: this.space.assassinGame.pollCounterYes,
            pollStatus: this.space.assassinGame.pollStatus,
            timeToFinishPoll: this.space.assassinGame.timeToFinishPoll,
            timeToKill: this.space.assassinGame.timeToKill,
            timeToReport: this.space.assassinGame.timeToReport,
            lastSpaceUserReportedId:
              this.space.assassinGame.lastSpaceUserReportedId,
            userVoted: this.space.assassinGame.userVoted,
            textLog: this.space.assassinGame.textLog,
          };
          if (this.gameData == null) {
            this.$store.dispatch(
              "GameKillerStore/setGameKillerDataAction",
              data
            );
            this.$store.dispatch(
              "GameKillerStore/setGameKillerTimerVoteAction",
              data.timeToFinishPoll
            );
            this.$store.dispatch(
              "GameKillerStore/setGameKillerTimerReportAction",
              data.timeToReport
            );
            this.$store.dispatch(
              "GameKillerStore/setGameKillerUserVotedAction",
              data.userVoted
            );
            if (this.killer && data.pollStatus == "IN_PROCESS") {
              GraphicClient.sendMessage(
                MessageType.USER,
                UserSendMessageType.YOU_KILL,
                false
              );
            }
            if (this.killer)
              this.$store.dispatch(
                "GameKillerStore/setGameKillerTimerKillerAction",
                data.timeToKill
              );
            if (this.user.timeToReportPenalty > 0) {
              this.$store.dispatch(
                "GameKillerStore/setGameKillerTimerBanAction",
                this.user.timeToReportPenalty
              );
            }
          }
        }
      }, 0);
    }
    return e;
  }
  get killer() {
    return this.$store.getters["UserStore/getGameKiller"];
  }
  get space() {
    let space = this.$store.getters["SpaceStore/getSpace"];
    return space;
  }
  get user(): SpaceUserInterface {
    let user = this.$store.getters["UserStore/getSpaceUser"];
    return user;
  }
  set active(e) {
    this.$store.dispatch("SystemStore/setGameKillerInfoModalAction", e);
  }
  get timeKiller() {
    return this.$store.getters["GameKillerStore/getGameKillerTimerKiller"];
  }
  get gameData() {
    let data = this.$store.getters["GameKillerStore/getGameKillerData"];
    if (data && data.pollStatus == "IN_PROCESS" && data.timeToFinishPoll >= 0) {
      if (
        !this.timerVote &&
        this.$store.getters["GameKillerStore/getGameKillerTimerVote"] > 1
      ) {
        this.activeReport = false;
        this.activeVoting = true;
        this.startCountdownVote();
      }
    }
    if (data && data.pollStatus == "CLOSED") {
      this.activeVoting = false;
    }
    if (data && data.timeToKill >= 0) {
      if (
        !this.timerKiller &&
        this.$store.getters["GameKillerStore/getGameKillerTimerKiller"] > 1
      ) {
        GraphicClient.sendMessage(
          MessageType.USER,
          UserSendMessageType.YOU_KILL,
          false
        );
        this.startCountdownKiller();
      }
    }
    if (this.user.timeToReportPenalty >= 0) {
      if (
        !this.timerBan &&
        this.$store.getters["GameKillerStore/getGameKillerTimerBan"] > 1
      ) {
        this.startCountdownBan();
      }
    }
    if (data && data.timeToReport >= 0) {
      if (
        !this.timerReport &&
        this.$store.getters["GameKillerStore/getGameKillerTimerReport"] > 1
      ) {
        this.startCountdownReport();
      }
    }
    this.updateScroll();

    if (!this.space.isAssassinGameActivated) {
      this.isShowDiary = true;
    }
    return data;
  }
  get activateInformation() {
    const e =
      this.$store.getters["SystemStore/getGameKillerVoteAndWinnerModal"];
    return e;
  }
  get gamekillerWinner() {
    let data = this.$store.getters["SystemStore/getGameKillerWinner"];
    return data;
  }
  get lastDeath() {
    return this.$store.getters["GameKillerStore/getGameKillerLastDead"];
  }
  setMinimize(data) {
    this.isMinimized = data;
    this.clearTooltip();
  }
  showTutorial() {
    this.$store.dispatch("SystemStore/setGameKillerModalAction", true);
  }
  report() {
    this.selectedUser = "";
    if (!this.activeReport) this.getUserOnline();
    this.activeReport = !this.activeReport;
  }
  sendVote() {
    this.loadVote = true;
    this.$store.dispatch("GameKillerStore/votePlayerGameKillerAction", {
      spaceId: this.space.id,
      data: {
        vote: this.expulsionYes ? true : false,
      },
      callback: (response) => {
        this.loadVote = false;
        this.checkDisable();
        this.saveVote();
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.sendVoteOk")
        );
      },
      callbackError: (error) => {
        console.log("TTT sendReport KO");
        this.loadVote = false;
        this.onError("", error.response.data.detail);
      },
    });
  }
  sendReport() {
    this.loadReport = true;
    this.$store.dispatch("GameKillerStore/reportPlayerGameKillerAction", {
      spaceUserId: this.selectedUser,
      data: {
        description: this.description,
      },
      callback: (response) => {
        this.selectedUser = "";
        this.description = "";
        this.loadReport = false;
        this.activeReport = false;
        this.activeVoting = true;
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.sendReportOk")
        );
      },
      callbackError: (error) => {
        console.log("TTT sendReport KO");
        this.loadReport = false;
        this.onError("", error.response.data.detail);
      },
    });
  }
  checkButton(): boolean {
    if (this.description && this.selectedUser) return false;
    return true;
  }
  checkButtonVote(): boolean {
    if (this.user.isDeadInAssassinGame) return true;
    if (this.$store.getters["GameKillerStore/getGameKillerUserVoted"])
      return true;
    if (this.expulsionNo || this.expulsionYes) return false;
    return true;
  }
  checkButtonReport(): boolean {
    if (this.$store.getters["GameKillerStore/getGameKillerTimerBan"] > 1) {
      return true;
    }
    if (
      this.gameData &&
      this.$store.getters["GameKillerStore/getGameKillerTimerReport"] > 1
    )
      return true;
    if (this.user && this.user.isDeadInAssassinGame) return true;
    return false;
  }
  close() {
    this.active = false;
  }
  clearTooltip() {
    const tooltip = document.getElementsByClassName("vs-tooltip");
    if (tooltip)
      while (tooltip.length > 0) {
        tooltip[0].parentNode.removeChild(tooltip[0]);
      }
  }
  getUserOnline() {
    let spaceUser = this.$store.getters["UserStore/getSpaceUser"];
    this.loadUsers = true;
    this.$store.dispatch("SpaceStore/getSpaceUsersOnlineAction", {
      spaceId: this.space.id,
      callback: (response) => {
        this.loadUsers = false;
        let users = response.filter(
          (user) =>
            !user.isDeadInAssassinGame &&
            user.connectionStatus === "ONLINE" &&
            user.superSpaceUser.user.id != spaceUser.superSpaceUser.user.id
        );
        this.listUsers = users;
      },
      callbackError: (error) => {
        console.log("TTT getUserOnline KO");
        this.loadUsers = false;
        this.onError("", error.response.data.detail);
      },
    });
  }
  setCheckbox(checkbox: any): void {
    let vsCheckbox = document.getElementsByClassName("vs-checkbox");
    for (var i = 0, l = vsCheckbox.length; i < l; ++i) {
      let element = vsCheckbox[i] as HTMLInputElement;
      if (
        element.id != checkbox.target.id &&
        checkbox.target.name == "checkbox-1"
      ) {
        element.checked = false;
        this.expulsionNo = false;
        this.expulsionYes = true;
      }
      if (
        element.id != checkbox.target.id &&
        checkbox.target.name == "checkbox-2"
      ) {
        element.checked = false;
        this.expulsionYes = false;
        this.expulsionNo = true;
      }
    }
  }
  getPercentage(votes: any): any {
    let countVotes = this.gameData.pollCounterNo + this.gameData.pollCounterYes;
    let result = votes * (100 / countVotes);
    return result ? result.toFixed(1) : 0;
  }
  startCountdownVote() {
    this.timerVote = setInterval(() => {
      let segVote =
        this.$store.getters["GameKillerStore/getGameKillerTimerVote"];
      segVote--;
      if (segVote > 0) {
        this.$store.dispatch(
          "GameKillerStore/setGameKillerTimerVoteAction",
          segVote
        );
        this.formatTime(segVote, "VOTE");
      } else {
        clearInterval(this.timerVote);
        this.timerVote = null;
        this.timePoll = i18n.t("gameKiller.resultWaiting").toString();
      }
    }, 1000);
  }
  startCountdownReport() {
    this.timerReport = setInterval(() => {
      let segReport =
        this.$store.getters["GameKillerStore/getGameKillerTimerReport"];
      segReport--;
      if (segReport > 0) {
        this.$store.dispatch(
          "GameKillerStore/setGameKillerTimerReportAction",
          segReport
        );
        if (this.timerBan) {
          if (this.timerReport) {
            clearInterval(this.timerReport);
            this.timerReport = null;
          }
          return;
        }
        this.formatTime(segReport, "REPORT");
      } else {
        clearInterval(this.timerReport);
        this.timerReport = null;
        this.textButonReport = i18n.t("gameKiller.report");
      }
    }, 1000);
  }
  startCountdownKiller() {
    this.timerKiller = setInterval(() => {
      let segKiller =
        this.$store.getters["GameKillerStore/getGameKillerTimerKiller"];
      segKiller--;
      if (segKiller > 0) {
        this.$store.dispatch(
          "GameKillerStore/setGameKillerTimerKillerAction",
          segKiller
        );
        this.formatTime(segKiller, "KILLER");
      } else {
        clearInterval(this.timerKiller);
        this.timerKiller = null;
        this.textTimerKiller = "";
        if (!this.activeVoting)
          GraphicClient.sendMessage(
            MessageType.USER,
            UserSendMessageType.YOU_KILL,
            true
          );
      }
    }, 1000);
  }
  formatTime(seconds, type) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secondsLeft = seconds % 60;

    switch (type) {
      case "VOTE":
        this.timePoll = `${minutes}:${
          secondsLeft < 10 ? "0" : ""
        }${secondsLeft}`;
        break;

      case "REPORT":
        this.textButonReport = `${minutes}:${
          secondsLeft < 10 ? "0" : ""
        }${secondsLeft}`;
        break;

      case "KILLER":
        this.textTimerKiller = `${minutes}:${
          secondsLeft < 10 ? "0" : ""
        }${secondsLeft}`;
        break;

      case "BAN":
        this.textButonReport = `${hours < 10 ? "0" : ""}${hours}:${
          minutes < 10 ? "0" : ""
        }${minutes}:${secondsLeft < 10 ? "0" : ""}${secondsLeft}`;
        break;
    }
  }
  saveVote() {
    this.$store.dispatch("GameKillerStore/setGameKillerUserVotedAction", true);
  }
  checkDisable() {
    let vsCheckbox = document.getElementsByClassName("vs-checkbox");
    for (var i = 0, l = vsCheckbox.length; i < l; ++i) {
      let element = vsCheckbox[i] as HTMLInputElement;
      element.style.visibility = "hidden";
    }
  }
  closeMessage() {
    this.$store.dispatch(
      "SystemStore/setGameKillerVoteAndWinnerModalAction",
      false
    );
    if (!this.space.isAssassinGameActivated)
      this.$store.dispatch("SystemStore/setGameKillerInfoModalAction", false);
  }
  closeLastDead() {
    this.$store.dispatch("GameKillerStore/setGameKillerLastDeadAction", null);
  }
  closeShowDiary() {
    this.isShowDiary = false;
    if (!this.space.isAssassinGameActivated) {
      this.active = false;
    }
  }
  startCountdownBan() {
    this.timerBan = setInterval(() => {
      let segban = this.$store.getters["GameKillerStore/getGameKillerTimerBan"];
      segban--;
      if (segban > 0) {
        this.$store.dispatch(
          "GameKillerStore/setGameKillerTimerBanAction",
          segban
        );
        this.formatTime(segban, "BAN");
      } else {
        clearInterval(this.timerBan);
        this.timerBan = null;
        this.textButonReport = i18n.t("gameKiller.report");
      }
    }, 1000);
  }
  loadText() {
    switch (i18n.locale) {
      case "es":
        return this.gameData.textLog?.spanish;

      case "ca":
        return this.gameData.textLog?.catalan;

      case "fr":
        return this.gameData.textLog?.french;

      default:
        return this.gameData.textLog?.english;
    }
  }
  showDiary() {
    this.isShowDiary = true;
  }
  updateScroll() {
    let preContainer = document.getElementById("game-killer-pre");
    if (preContainer) preContainer.scrollTop = preContainer.scrollHeight;
  }
}
